<template>
  <section class="section-slide">
    <div class="wrap-slick1">
      <div class="slick1">
        <div
          class="item-slick1 item1-slick1"
          style="background-image: url(/static/images/slide1-01.jpg);"
        >
          <div class="wrap-content-slide1 sizefull flex-col-c-m p-l-15 p-r-15 p-t-150 p-b-170">
            <span
              class="caption1-slide1 txt1 t-center animated visible-false m-b-15"
              data-appear="fadeInDown"
            >{{ $t("hello.welcome1") }}</span>
            <h2
              class="caption2-slide1 tit1 t-center animated visible-false m-b-37"
              data-appear="fadeInUp"
            >{{ $t("hello.welcome2") }}</h2>
            <div class="wrap-btn-slide1 animated visible-false" data-appear="zoomIn">
              <!-- Button1 -->

              <router-link
                to="/"
                style="text-decoration:none;"
                class="btn1 flex-c-m size1 txt3 trans-0-4"
              >{{ $t("column.news") }}</router-link>
            </div>
          </div>
        </div>
        <div
          class="item-slick1 item2-slick1"
          style="background-image: url(/static/images/slide1-02.jpg);"
        >
          <div class="wrap-content-slide1 sizefull flex-col-c-m p-l-15 p-r-15 p-t-150 p-b-170">
            <span
              class="caption1-slide1 txt1 t-center animated visible-false m-b-15"
              data-appear="rollIn"
            >{{ $t("hello.welcome1") }}</span>
            <h2
              class="caption2-slide1 tit1 t-center animated visible-false m-b-37"
              data-appear="lightSpeedIn"
            >{{ $t("hello.welcome2") }}</h2>
            <div class="wrap-btn-slide1 animated visible-false" data-appear="slideInUp">
              <router-link
                to="/"
                style="text-decoration:none;"
                class="btn1 flex-c-m size1 txt3 trans-0-4"
              >{{ $t("column.news") }}</router-link>
            </div>
          </div>
        </div>
        <div
          class="item-slick1 item3-slick1"
          style="background-image: url(/static/images/slide1-03.jpg);"
        >
          <div class="wrap-content-slide1 sizefull flex-col-c-m p-l-15 p-r-15 p-t-150 p-b-170">
            <span
              class="caption1-slide1 txt1 t-center animated visible-false m-b-15"
              data-appear="rotateInDownLeft"
            >{{ $t("hello.welcome1") }}</span>
            <h2
              class="caption2-slide1 tit1 t-center animated visible-false m-b-37"
              data-appear="rotateInUpRight"
            >{{ $t("hello.welcome2") }}</h2>
            <div class="wrap-btn-slide1 animated visible-false" data-appear="rotateIn">
              <!-- Button1 -->
              <router-link
                to="/"
                style="text-decoration:none;"
                class="btn1 flex-c-m size1 txt3 trans-0-4"
              >{{ $t("column.news") }}</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-slick1-dots"></div>
    </div>
  </section>
</template>

<style scoped >
</style>
<script >
export default {
  name: "Slide"
};
</script>



// WEBPACK FOOTER //
// src/components/Slide.vue